import type { FaireProductEntity } from "../../entity_types/product";

export const p_xh2ydbj634: FaireProductEntity = {
  token: "p_xh2ydbj634",
  type: "product",
  name: "Glossy 18K Gold Plated Stainless Steel Hoop Earrings - FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl: "https://cdn.faire.com/fastly/60ca9d74afdfb96ec727066df7506d3c7d7ebe134c4bf2181e04f82f0af0766d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/332057546e02ad2c253615ff82dbf44b5a3a93de3496ac58c577b1c3b348568f.jpeg",
    "https://cdn.faire.com/fastly/746791c1a3de2afae69d36685c7d9d3ff0467e495d237ea2ece5ed6ceb63ae5b.jpeg",
    "https://cdn.faire.com/fastly/05bb8610bb982c547fa6e049b690f0ef5f19aa479cf4f7c579ace8f092e17362.jpeg"
  ],
  priceDollars: 10.43,
  description: "Type: Earrings\nMaterial : Stainless steel ,18K gold plated\nSize :9mm*23mm\nProcess: Vacuum electroplating and manual polishing,Non tarnish\nSurface : High Polish\n★Made of high quality stainless steel,Lead-free,Harmless to Human Body.\n★Perfect jewelry gifts ",
  tags: [],
  msrpDollars: 26.08,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:42.117Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
